
  export default {
    name: `ClientDocumentsPage`,
    middleware({ $gates, store, route, redirect }) {
      const path = route.path
      const urlWithoutLastSlash = path.replace(/\/$/, ``)
      const permissionFromUrl = store.getters[`menu/getPermissionFromUrl`](urlWithoutLastSlash)
      const hasPermission = permissionFromUrl ? $gates.hasPermission(permissionFromUrl) : false
      if (!hasPermission) {
        redirect(`/`)
      }
    },
    data() {
      return {
        documents: null,
        docRefresh: 0
      }
    },
    computed: {
      isConsultOnly() {
        return this.$store.getters[`permissions/userIsConsultonly`]
      }
    },
    mounted() {
      if (this.checkPermission()) {
        this.getDocuments()
      } else {
        this.$router.push(`/`)
      }
    },
    methods: {
      checkPermission() {
        const path = this.$route.path
        const urlWithoutLastSlash = path.replace(/\/$/, ``)
        const permissionFromUrl = this.$store.getters[`menu/getPermissionFromUrl`](urlWithoutLastSlash)
        if (!!permissionFromUrl) {
          return this.$gates.hasPermission(permissionFromUrl)
        } else {
          return false
        }
      },
      getDocuments() {
        return this.$api.client.documents().then((res) => {
          if (!!res) {
            this.documents = res
            this.docRefresh += 1
          }
        })
      },
      getLabel() {
        return !this.isConsultOnly ? this.$t(`pages.client.add_documents`) : ``
      },
      saveDocuments(data) {
        if (!!data?.new && data.new.length > 0) {
          const params = {
            newDocuments: data.new
          }
          this.$api.client
            .saveDocuments(params)
            .then((res) => {
              if (!!res) {
                this.$flashMessage.success({
                  title: this.$t(`messages.success`),
                  message: this.$t(`messages.document_saved`)
                })
              }
            })
            .catch((err) => {
              if (err?.response?.status === 400) {
                this.$flashMessage.error({
                  title: `<${this.$options.name}> : ${this.$t(`messages.error`)}`,
                  message: this.$t(`messages.cant_save_document`)
                })
              }
            })
            .finally(() => {
              this.getDocuments()
            })
        }
      }
    }
  }
